'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var airlines = [{
    code: '0B',
    name: 'Blue Air'
}, {
    code: '0C',
    name: 'Cobra Aviation'
}, {
    code: '0E',
    name: 'Aircompany North-West'
}, {
    code: '0J',
    name: 'Premium Jet'
}, {
    code: '0V',
    name: 'VASCO'
}, {
    code: '1F',
    name: 'Forward Air'
}, {
    code: '1I',
    name: 'NetJets Aviation'
}, {
    code: '1M',
    name: 'Online Reservation System JSC'
}, {
    code: '1X',
    name: 'Branson Air Express'
}, {
    code: '2A',
    name: 'Deutsche Bahn'
}, {
    code: '2B',
    name: 'Albawings'
}, {
    code: '2C',
    name: 'SNCF'
}, {
    code: '2D',
    name: 'Eastern Airlines'
}, {
    code: '2E',
    name: 'Smokey Bay Air'
}, {
    code: '2F',
    name: 'Frontier Flying Service'
}, {
    code: '2G',
    name: 'Angara Airlines'
}, {
    code: '2H',
    name: 'Thalys International'
}, {
    code: '2I',
    name: 'Star Peru'
}, {
    code: '2J',
    name: 'Air Burkina'
}, {
    code: '2K',
    name: 'Avianca Ecuador'
}, {
    code: '2L',
    name: 'Helvetic Airways'
}, {
    code: '2M',
    name: 'Maya Island Air'
}, {
    code: '2O',
    name: 'Island Air Service'
}, {
    code: '2P',
    name: 'PAL Express and Airphil Express'
}, {
    code: '2R',
    name: 'VIA Rail Canada'
}, {
    code: '2U',
    name: 'Sun d\'Or'
}, {
    code: '2V',
    name: 'Amtrak'
}, {
    code: '2W',
    name: 'Welcome Air'
}, {
    code: '2Y',
    name: 'Air Andaman'
}, {
    code: '2Z',
    name: 'VoePass'
}, {
    code: '3A',
    name: 'Alliance Airlines'
}, {
    code: '3B',
    name: 'Bestfly Cabo Verde'
}, {
    code: '3C',
    name: 'Air Chathams'
}, {
    code: '3E',
    name: 'Air Choice One'
}, {
    code: '3F',
    name: 'FLYONE ARMENIA'
}, {
    code: '3H',
    name: 'Air Inuit'
}, {
    code: '3J',
    name: 'Jubba Airways (Kenya)'
}, {
    code: '3L',
    name: 'Intersky Luftfahrt'
}, {
    code: '3M',
    name: 'Silver Airways'
}, {
    code: '3N',
    name: 'Air Urga'
}, {
    code: '3O',
    name: 'Air Arabia Maroc'
}, {
    code: '3P',
    name: 'World 2 Fly Portugal'
}, {
    code: '3Q',
    name: 'Royal Air Charters'
}, {
    code: '3R',
    name: 'Divi Divi Air'
}, {
    code: '3S',
    name: 'Air Antilles Express'
}, {
    code: '3T',
    name: 'Tarco Aviation'
}, {
    code: '3U',
    name: 'Sichuan Airlines'
}, {
    code: '3V',
    name: 'ASL Airlines Belgium'
}, {
    code: '3W',
    name: 'Malawi Airlines'
}, {
    code: '3X',
    name: 'Japan Air Commuter'
}, {
    code: '3Z',
    name: 'Everts Air Cargo'
}, {
    code: '4A',
    name: 'ATSA Airlines'
}, {
    code: '4C',
    name: 'LATAM Airlines Colombia'
}, {
    code: '4D',
    name: 'Air Sinai'
}, {
    code: '4E',
    name: 'Tanana Air Service'
}, {
    code: '4F',
    name: 'Freedom Airline Express'
}, {
    code: '4G',
    name: 'Gazpromavia'
}, {
    code: '4H',
    name: 'Hi Air'
}, {
    code: '4J',
    name: 'Jetair Caribbean'
}, {
    code: '4L',
    name: 'Georgian International Airlines'
}, {
    code: '4N',
    name: 'Air North'
}, {
    code: '4P',
    name: 'Regional Sky'
}, {
    code: '4Q',
    name: 'Safi Airways'
}, {
    code: '4R',
    name: 'Renfre Viajeros'
}, {
    code: '4S',
    name: 'Solar Cargo'
}, {
    code: '4T',
    name: 'Belair Airlines'
}, {
    code: '4V',
    name: 'Lignes Aeriennes Congolaises'
}, {
    code: '4W',
    name: 'Warbelow'
}, {
    code: '4X',
    name: 'Mercury World Cargo'
}, {
    code: '4Y*',
    name: 'Discover Airlines'
}, {
    code: '4Z',
    name: 'Airlink'
}, {
    code: '5A',
    name: 'Alpine Air Express'
}, {
    code: '5B',
    name: 'Bassaka Air'
}, {
    code: '5C',
    name: 'C.A.L. Cargo Airlines'
}, {
    code: '5D',
    name: 'AeroMexico Connect'
}, {
    code: '5F',
    name: 'Fly One'
}, {
    code: '5G',
    name: 'Shirak Avia'
}, {
    code: '5J',
    name: 'Cebu Pacific Air'
}, {
    code: '5K',
    name: 'Hi Fly'
}, {
    code: '5M',
    name: 'FlyMontserrat'
}, {
    code: '5N',
    name: 'Smartavia'
}, {
    code: '5O',
    name: 'ASL Airlines France'
}, {
    code: '5R',
    name: 'Rutaca Airlines'
}, {
    code: '5S',
    name: 'Global Air Transport'
}, {
    code: '5T',
    name: 'Canadian North'
}, {
    code: '5U',
    name: 'LADE'
}, {
    code: '5V',
    name: 'Everts Air Cargo'
}, {
    code: '5W',
    name: 'Wizz Air Abu Dhabi'
}, {
    code: '5X',
    name: 'UPS'
}, {
    code: '5Y',
    name: 'Atlas Air'
}, {
    code: '5Z',
    name: 'CemAir'
}, {
    code: '6A',
    name: 'Armenia Airways'
}, {
    code: '6B',
    name: 'TUIfly Nordic'
}, {
    code: '6D',
    name: 'PT. Pelita Air'
}, {
    code: '6E',
    name: 'IndiGo'
}, {
    code: '6G',
    name: 'Southern Airways Express'
}, {
    code: '6H',
    name: 'Israir Airlines'
}, {
    code: '6I',
    name: 'Air Alsie'
}, {
    code: '6J',
    name: 'Jubba Airways'
}, {
    code: '6L',
    name: 'Aklak Air'
}, {
    code: '6M',
    name: 'Maximus Air'
}, {
    code: '6N',
    name: 'Al-Naser Airlines'
}, {
    code: '6O',
    name: 'Orbest Airlines'
}, {
    code: '6P',
    name: 'Gryphon Airlines'
}, {
    code: '6R',
    name: 'Alrosa'
}, {
    code: '6T',
    name: 'Longtail Aviation'
}, {
    code: '6W',
    name: 'FlyBosnia'
}, {
    code: '6Y',
    name: 'SmartLynx Airlines'
}, {
    code: '7A',
    name: 'Express Air'
}, {
    code: '7B',
    name: 'Bees Airline'
}, {
    // NOTE: This will map to 7C in the backend and is causing issues
    //       because a Cargo airline (Coyne Airways) shares the same iata
    //       code of 7C
    code: '7C*',
    name: 'Jeju Airlines'
}, {
    code: '7E',
    name: 'Sylt Air'
}, {
    code: '7G',
    name: 'StarFlyer'
}, {
    code: '7H',
    name: 'Ravn Alaska'
}, {
    code: '7I',
    name: 'Air Libya'
}, {
    code: '7J',
    name: 'Tajik Air'
}, {
    code: '7K',
    name: 'CSafe Global'
}, {
    code: '7L',
    name: 'Silk Way West'
}, {
    code: '7M',
    name: 'MAYAir'
}, {
    code: '7N',
    name: 'MetroJets'
}, {
    code: '7O',
    name: 'Smartwings Hungary Kft'
}, {
    code: '7P',
    name: 'Air Panama'
}, {
    code: '7Q',
    name: 'PAWA Dominicana'
}, {
    code: '7R',
    name: 'RusLine'
}, {
    code: '7S',
    name: 'Ryan Air'
}, {
    code: '7U',
    name: 'Commercial Aviation Services'
}, {
    code: '7V',
    name: 'Federal Air'
}, {
    code: '7W',
    name: 'Wind Rose Aviation Company'
}, {
    code: '7Y',
    name: 'Mid Airlines'
}, {
    code: '7Z',
    name: 'Halcyonair Cabo Verde Airways S.A.'
}, {
    code: '8A',
    name: 'Panama Airways'
}, {
    code: '8B',
    name: 'TransNusa'
}, {
    code: '8C',
    name: 'ATI'
}, {
    code: '8D',
    name: 'FitsAir'
}, {
    code: '8E',
    name: 'Bering Air'
}, {
    code: '8F',
    name: 'STP Airways'
}, {
    code: '8G',
    name: 'Aero Dili Transport Services'
}, {
    code: '8L',
    name: 'Lucky Air'
}, {
    code: '8M',
    name: 'Myanmar Airways International'
}, {
    code: '8N',
    name: 'Regional Air'
}, {
    code: '8P',
    name: 'Pacific Coastal Airlines'
}, {
    code: '8R',
    name: 'AMELIA'
}, {
    code: '8S',
    name: 'Turbojet'
}, {
    code: '8T',
    name: 'Air Tindi'
}, {
    code: '8U',
    name: 'Afriqiyah Airways'
}, {
    code: '8V',
    name: 'Wright Air Service'
}, {
    code: '8W',
    name: 'Private Wings'
}, {
    code: '8Y',
    name: 'Air Burundi'
}, {
    code: '8Z',
    name: 'Congo Airways'
}, {
    code: '9B',
    name: 'AccesRail'
}, {
    code: '9C',
    name: 'Spring Airlines'
}, {
    code: '9D',
    name: 'Genghis Khan Airlines'
}, {
    code: '9E',
    name: 'Endeavor Air'
}, {
    code: '9F',
    name: 'Eurostar'
}, {
    code: '9H',
    name: 'Air Changan'
}, {
    code: '9I',
    name: 'Helitrans AS'
}, {
    code: '9J',
    name: 'Dana Airlines'
}, {
    code: '9K',
    name: 'Cape Air'
}, {
    code: '9L',
    name: 'AirTanker Services'
}, {
    code: '9M',
    name: 'Central Mountain Air'
}, {
    code: '9N',
    name: 'Tropic Air'
}, {
    code: '9O',
    name: 'The Cargo Flights'
}, {
    code: '9P',
    name: 'Fly Jinnah'
}, {
    code: '9Q',
    name: 'Caicos Express Airways'
}, {
    code: '9R',
    name: 'SATENA'
}, {
    code: '9U',
    name: 'Air Moldova'
}, {
    code: '9V',
    name: 'Avior Airlines'
}, {
    code: '9X',
    name: 'Southern Airways Express'
}, {
    code: 'A2',
    name: 'Anima Wings'
}, {
    code: 'A3',
    name: 'Aegean Airlines'
}, {
    code: 'A4',
    name: 'Aerocon'
}, {
    code: 'A5',
    name: 'HOP!'
}, {
    code: 'A6',
    name: 'Air Travel'
}, {
    code: 'A8',
    name: 'Aerolink Uganda'
}, {
    code: 'A9',
    name: 'Georgian Airways'
}, {
    code: 'AA',
    name: 'American Airlines'
}, {
    code: 'AC',
    name: 'Air Canada'
}, {
    code: 'AD',
    name: 'Azul'
}, {
    code: 'AE',
    name: 'Mandarin Airlines'
}, {
    code: 'AF',
    name: 'Air France'
}, {
    code: 'AFE',
    name: 'AIRFAST Indonesia'
}, {
    code: 'AG',
    name: 'ASL Airlines Ireland'
}, {
    code: 'AH',
    name: 'Air Algerie'
}, {
    code: 'AI',
    name: 'Air India'
}, {
    code: 'AJ',
    name: 'Aero Contractors'
}, {
    code: 'AK',
    name: 'AirAsia'
}, {
    code: 'AM',
    name: 'Aeromexico'
}, {
    code: 'AN',
    name: 'Advanced Air'
}, {
    code: 'AO',
    name: 'Air Juan'
}, {
    code: 'AP',
    name: 'AlbaStar'
}, {
    code: 'AQ',
    name: '9 Air Co'
}, {
    code: 'AR',
    name: 'Aerolineas Argentinas'
}, {
    code: 'AS',
    name: 'Alaska Airlines'
}, {
    code: 'ASJ',
    name: 'AstonJet'
}, {
    code: 'AT',
    name: 'Royal Air Maroc'
}, {
    code: 'AU',
    name: 'Austral'
}, {
    code: 'AV',
    name: 'SA AVIANCA'
}, {
    code: 'AW',
    name: 'Africa World Airlines'
}, {
    code: 'AX',
    name: 'Trans States Airlines'
}, {
    code: 'AY',
    name: 'Finnair'
}, {
    code: 'AYN',
    name: 'FlyArystan'
}, {
    code: 'AZ',
    name: 'ITA Airways'
}, {
    code: 'B0',
    name: 'La Compagnie'
}, {
    code: 'B2',
    name: 'Belavia'
}, {
    code: 'B3',
    name: 'Tashi Air Pvt Ltd'
}, {
    code: 'B6',
    name: 'JetBlue Airways'
}, {
    code: 'B7',
    name: 'UNI Air'
}, {
    code: 'B8',
    name: 'Eritrean Airlines s.c.'
}, {
    code: 'B9',
    name: 'Iran Airtour'
}, {
    code: 'BA',
    name: 'British Airways'
}, {
    code: 'BB',
    name: 'Seaborne Airlines'
}, {
    code: 'BC',
    name: 'Skymark Airlines'
}, {
    code: 'BD',
    name: 'Budget Lines'
}, {
    code: 'BE',
    name: 'Flybe'
}, {
    code: 'BF',
    name: 'French Bee'
}, {
    code: 'BG',
    name: 'Biman Bangladesh Airlines'
}, {
    code: 'BH',
    name: 'Bismillah Airlines'
}, {
    code: 'BI',
    name: 'Royal Brunei Airlines'
}, {
    code: 'BJ',
    name: 'Nouvelair Tunisie'
}, {
    code: 'BK',
    name: 'Okay Airways'
}, {
    code: 'BL',
    name: 'Pacific Airlines'
}, {
    code: 'BN',
    name: 'Luxwing'
}, {
    code: 'BO',
    name: 'Bluebird Nordic'
}, {
    code: 'BP',
    name: 'Air Botswana'
}, {
    code: 'BR',
    name: 'EVA Air'
}, {
    code: 'BS',
    name: 'British International'
}, {
    code: 'BT',
    name: 'Air Baltic'
}, {
    code: 'BU',
    name: 'CAA'
}, {
    code: 'BW',
    name: 'Caribbean Airlines'
}, {
    code: 'BX',
    name: 'Air Busan'
}, {
    code: 'BY',
    name: 'TUI Airways'
}, {
    code: 'C2',
    name: 'CEIBA Intercontinental'
}, {
    code: 'C3',
    name: 'ICAR Airlines'
}, {
    code: 'C4',
    name: 'Conquest Air'
}, {
    code: 'C5',
    name: 'CommutAir'
}, {
    code: 'C6',
    name: 'Unilode Aviation Solutions New Zealand'
}, {
    code: 'C7',
    name: 'Cinnamon Air'
}, {
    code: 'C8',
    name: 'CRONOSAIR'
}, {
    code: 'C9',
    name: 'Cronos Airlines Benin'
}, {
    code: 'CA',
    name: 'Air China'
}, {
    code: 'CB',
    name: 'Trans Caribbean Air'
}, {
    code: 'CC',
    name: 'Macair Airlines'
}, {
    code: 'CD',
    name: 'Alliance Air'
}, {
    code: 'CE',
    name: 'Route de Caen'
}, {
    code: 'CF',
    name: 'China Postal Airlines'
}, {
    code: 'CG',
    name: 'PNG Air'
}, {
    code: 'CH',
    name: 'Bemidji Aviation'
}, {
    code: 'CI',
    name: 'China Airlines'
}, {
    code: 'CJ',
    name: 'BA Cityflyer'
}, {
    code: 'CK',
    name: 'China Cargo'
}, {
    code: 'CL',
    name: 'Lufthansa CityLine'
}, {
    code: 'CM',
    name: 'Copa Airlines'
}, {
    code: 'CN',
    name: 'Grand China Air'
}, {
    code: 'CO',
    name: 'North-Western Cargo International Airlines'
}, {
    code: 'CQ',
    name: 'Sunshine Express Airlines'
}, {
    code: 'CS',
    name: 'Chair Airways'
}, {
    code: 'CT',
    name: 'Air Atlanta Europe'
}, {
    code: 'CU',
    name: 'Cubana de Aviacion'
}, {
    code: 'CV',
    name: 'Cargolux'
}, {
    code: 'CX',
    name: 'Cathay Pacific'
}, {
    code: 'CY',
    name: 'Cyprus Airways'
}, {
    code: 'CZ',
    name: 'China Southern Airlines'
}, {
    code: 'D0',
    name: 'DHL Air'
}, {
    code: 'D2',
    name: 'Severstal Aircompany'
}, {
    code: 'D3',
    name: 'Daallo Airlines'
}, {
    code: 'D4',
    name: 'Alidaunia'
}, {
    code: 'D5',
    name: 'DHL Aero Expreso'
}, {
    code: 'D6',
    name: 'Interair South Africa'
}, {
    code: 'D7',
    name: 'AirAsia X'
}, {
    code: 'D8',
    name: 'Norwegian Air International'
}, {
    code: 'D9',
    name: 'Daallo Airlines (Somalia)'
}, {
    code: 'DB',
    name: 'HOP!-BRIT AIR'
}, {
    code: 'DC',
    name: 'Air Georgia'
}, {
    code: 'DD',
    name: 'Nok Air'
}, {
    code: 'DE',
    name: 'Condor'
}, {
    code: 'DG',
    name: 'Cebgo'
}, {
    code: 'DI',
    name: 'Marabu Airlines'
}, {
    code: 'DH',
    name: 'Norwegian Air Norway'
}, {
    code: 'DJ',
    name: 'Virgin Blue'
}, {
    code: 'DK',
    name: 'Sunclass Airlines'
}, {
    code: 'DL',
    name: 'Delta Air Lines'
}, {
    code: 'DM',
    name: 'Arajet'
}, {
    code: 'DO',
    name: 'Sky High Aviation'
}, {
    code: 'DP',
    name: 'Pobeda'
}, {
    code: 'DQ',
    name: 'Coastal Air'
}, {
    code: 'DR',
    name: 'Ruili Airlines'
}, {
    code: 'DS',
    name: 'Easyjet Switzerland'
}, {
    code: 'DT',
    name: 'TAAG-Angola Airlines'
}, {
    code: 'DU',
    name: 'Air Liaison'
}, {
    code: 'DV',
    name: 'SCAT Airlines'
}, {
    code: 'DX',
    name: 'Danish Air'
}, {
    code: 'DY',
    name: 'Norwegian Air Shuttle'
}, {
    code: 'DZ',
    name: 'Donghai Airlines'
}, {
    code: 'E2',
    name: 'Eurowings Europe'
}, {
    code: 'E4',
    name: 'Eastok Avia'
}, {
    code: 'E5',
    name: 'Air Arabia Egypt'
}, {
    code: 'E6',
    name: 'Bringer Air Cargo Taxi'
}, {
    code: 'E9',
    name: 'Iberojet Airlines'
}, {
    code: 'EA',
    name: 'European Air Express'
}, {
    code: 'EB',
    name: 'Wamos Air'
}, {
    code: 'EC',
    name: 'LEVEL'
}, {
    code: 'ED',
    name: 'Air Explore'
}, {
    code: 'EE',
    name: 'Xfly'
}, {
    code: 'EF',
    name: 'AerCaribe Peru'
}, {
    code: 'EG',
    name: 'Aer Lingus UK'
}, {
    code: 'EH',
    name: 'ANA Wings'
}, {
    code: 'EI',
    name: 'Aer Lingus'
}, {
    code: 'EJ',
    name: 'New England Airlines'
}, {
    code: 'EK',
    name: 'Emirates'
}, {
    code: 'EM',
    name: 'Empire Airlines'
}, {
    code: 'EN',
    name: 'Air Dolomiti'
}, {
    code: 'EO',
    name: 'Pegas Fly'
}, {
    code: 'EP',
    name: 'Iran Aseman Airlines'
}, {
    code: 'EQ',
    name: 'TAME'
}, {
    // NOTE: this will map to HN in the backend
    code: 'EQX',
    name: '(HN) Equair'
}, {
    code: 'ER',
    name: 'Astar Air Cargo'
}, {
    code: 'ET',
    name: 'Ethiopian Airlines'
}, {
    code: 'EU',
    name: 'Chengdu Airlines'
}, {
    code: 'EV',
    name: 'ExpressJet'
}, {
    code: 'EW',
    name: 'Eurowings'
}, {
    code: 'EX',
    name: 'Avianca Express'
}, {
    code: 'EY',
    name: 'Etihad Airways'
}, {
    code: 'EZ',
    name: 'Sun-Air'
}, {
    code: 'F0',
    name: 'Fly Jordan'
}, {
    code: 'F2',
    name: 'Safarilink'
}, {
    code: 'F3',
    name: 'flyadeal'
}, {
    code: 'F4',
    name: 'Air Flamenco'
}, {
    code: 'F5',
    name: 'Aerotranscargo'
}, {
    code: 'F6',
    name: 'Fly2Sky'
}, {
    code: 'F7',
    name: 'LTD I Fly'
}, {
    code: 'F8',
    name: 'Flair Airlines'
}, {
    code: 'F9',
    name: 'Frontier Airlines'
}, {
    code: 'FA',
    name: 'Private Sky'
}, {
    code: 'FB',
    name: 'Bulgaria Air'
}, {
    code: 'FC',
    name: 'Link Airways'
}, {
    code: 'FD',
    name: 'Thai AirAsia'
}, {
    code: 'FE',
    name: '748 Air Services'
}, {
    code: 'FG',
    name: 'Ariana Afghan Airlines'
}, {
    code: 'FH',
    name: 'Freebird Airlines'
}, {
    code: 'FI',
    name: 'Icelandair'
}, {
    code: 'FJ',
    name: 'Fiji Airways'
}, {
    code: 'FK',
    name: 'KF Cargo'
}, {
    code: 'FM',
    name: 'Shanghai Airlines'
}, {
    code: 'FN',
    name: 'Fastjet Zimbabwe'
}, {
    code: 'FO',
    name: 'Flybondi'
}, {
    code: 'FP',
    name: 'FlyPelican'
}, {
    code: 'FR',
    name: 'Ryanair'
}, {
    code: 'FT',
    name: 'FlyEgypt'
}, {
    code: 'FU',
    name: 'Fuzhou Airlines'
}, {
    code: 'FV',
    name: 'Rossiya Airlines'
}, {
    code: 'FW',
    name: 'IBEX Airlines'
}, {
    code: 'FX',
    name: 'FedEx'
}, {
    code: 'FY',
    name: 'Firefly'
}, {
    code: 'FZ',
    name: 'flydubai'
}, {
    code: 'G2',
    name: 'Gullivair'
}, {
    code: 'G3',
    name: 'Gol'
}, {
    code: 'G4',
    name: 'Allegiant Air'
}, {
    code: 'G5',
    name: 'China Express Air'
}, {
    code: 'G7',
    name: 'GoJet Airlines'
}, {
    code: 'G8',
    name: 'Go First'
}, {
    code: 'G9',
    name: 'Air Arabia PJSC'
}, {
    code: 'GA',
    name: 'Garuda Indonesia'
}, {
    code: 'GB',
    name: 'ABX Air'
}, {
    code: 'GC',
    name: 'Global Feeder Services'
}, {
    code: 'GD',
    name: 'Aviair Pty Ltd'
}, {
    code: 'GE',
    name: 'LIFT'
}, {
    code: 'GF',
    name: 'Gulf Air'
}, {
    code: 'GG',
    name: 'Sky Lease Cargo'
}, {
    code: 'GH',
    name: 'Globus'
}, {
    code: 'GI',
    name: 'China Central Longhao'
}, {
    code: 'GJ',
    name: 'Loong Air'
}, {
    code: 'GK',
    name: 'Jetstar Japan'
}, {
    code: 'GL',
    name: 'Air Greenland'
}, {
    code: 'GO',
    name: 'ULS Airlines Cargo'
}, {
    code: 'GP',
    name: 'APG Airlines'
}, {
    code: 'GQ',
    name: 'Sky Express'
}, {
    code: 'GR',
    name: 'Aurigny Air Services'
}, {
    code: 'GS',
    name: 'Tianjin Airlines'
}, {
    code: 'GT',
    name: 'Air Guilin'
}, {
    code: 'GV',
    name: 'Grant Aviation'
}, {
    code: 'GW',
    name: 'Costa Rica Green Airways S.R.L dba Costa Rica Green Airways S.R.L'
}, {
    code: 'GX',
    name: 'Guangxi Beibu Gulf Airlines'
}, {
    code: 'GY',
    name: 'Colorful Guizhou Airlines'
}, {
    code: 'GZ',
    name: 'Air Rarotonga'
}, {
    code: 'H2',
    name: 'Sky Airline'
}, {
    code: 'H3',
    name: 'Harbour Air'
}, {
    code: 'H4',
    name: 'Heli Securite'
}, {
    code: 'H6',
    name: 'NIL'
}, {
    code: 'H7',
    name: 'Eagle Air'
}, {
    code: 'H8',
    name: 'Sky Airlines Peru'
}, {
    code: 'H9',
    name: 'Himalaya Airlines'
}, {
    code: 'HA',
    name: 'Hawaiian Airlines'
}, {
    code: 'HB',
    name: 'Homer Air'
}, {
    code: 'HC',
    name: 'Air Senegal'
}, {
    code: 'HD',
    name: 'Air Do'
}, {
    code: 'HE',
    name: 'LGW'
}, {
    code: 'HF',
    name: 'Air Cote D\'Ivoire'
}, {
    code: 'HG',
    name: 'Niki'
}, {
    code: 'HH',
    name: 'Taban Airlines'
}, {
    code: 'HI',
    name: 'Papillon Airways'
}, {
    code: 'HJ',
    name: 'Tasman Cargo Airlines'
}, {
    code: 'HK',
    name: 'Skippers Aviation'
}, {
    code: 'HM',
    name: 'Air Seychelles'
}, {
    code: 'HO',
    name: 'Juneyao Airlines'
}, {
    code: 'HP',
    name: 'Amapola'
}, {
    code: 'HR',
    name: 'Hahn Air'
}, {
    code: 'HS',
    name: 'Heli Securite'
}, {
    code: 'HT',
    name: 'Aeromist-Kharkov'
}, {
    code: 'HU',
    name: 'Hainan Airlines'
}, {
    code: 'HV',
    name: 'Transavia.com'
}, {
    code: 'HW',
    name: 'North-Wright Airways'
}, {
    code: 'HX',
    name: 'Hong Kong Airlines'
}, {
    code: 'HY',
    name: 'Uzbekistan Airways'
}, {
    code: 'HZ',
    name: 'Aurora'
}, {
    code: 'I2',
    name: 'Iberia Express'
}, {
    code: 'I4',
    name: 'Island Air Express'
}, {
    code: 'I5',
    name: 'AirAsia India'
}, {
    code: 'I6',
    name: 'Intermodalidad de Levante'
}, {
    code: 'I7',
    name: 'IndiaOne Air'
}, {
    code: 'I8',
    name: 'Izhavia'
}, {
    code: 'I9',
    name: 'China Central Airlines'
}, {
    code: 'IA',
    name: 'I A W'
}, {
    code: 'IB',
    name: 'Iberia'
}, {
    code: 'ID',
    name: 'Batik Air'
}, {
    code: 'IE',
    name: 'Solomon Airlines'
}, {
    code: 'IF',
    name: 'Islas Airways'
}, {
    code: 'IH',
    name: 'Southern Sky'
}, {
    code: 'II',
    name: 'IBC Airways'
}, {
    code: 'IJ',
    name: 'Spring Airlines Japan'
}, {
    code: 'IK',
    name: 'Air Kiribati'
}, {
    code: 'IL',
    name: 'Trigana Air'
}, {
    code: 'IM',
    name: 'Jupiter Jet'
}, {
    code: 'IN',
    name: 'Nam Air'
}, {
    code: 'IO',
    name: 'IrAero'
}, {
    code: 'IP',
    name: 'PT. Pelita Air'
}, {
    code: 'IQ',
    name: 'Qazaq Air'
}, {
    code: 'IR',
    name: 'Iran Air'
}, {
    code: 'IS',
    name: 'Sepehran Airlines'
}, {
    code: 'IT',
    name: 'Tigerair Taiwan'
}, {
    code: 'IU',
    name: 'Hevi Lift (PNG)'
}, {
    code: 'IV',
    name: 'GP Aviation'
}, {
    code: 'IW',
    name: 'Wings Air (Indonesia)'
}, {
    code: 'IX',
    name: 'AIR INDIA EXPRESS'
}, {
    code: 'IY',
    name: 'Yemenia'
}, {
    code: 'IZ',
    name: 'Arkia Israeli Airlines'
}, {
    code: 'J2',
    name: 'AZAL Azerbaijan Airlines'
}, {
    code: 'J3',
    name: 'Northwestern Air'
}, {
    code: 'J4',
    name: 'Buffalo Airways'
}, {
    code: 'J5',
    name: 'Alaska Seaplanes'
}, {
    code: 'J7',
    name: 'Afrijet'
}, {
    code: 'J8',
    name: 'Berjaya Air'
}, {
    code: 'J9',
    name: 'Jazeera Airways'
}, {
    code: 'JA',
    name: 'JetSMART'
}, {
    code: 'JC',
    name: 'Japan Air Commuter'
}, {
    code: 'JD',
    name: 'Beijing Capital Airlines'
}, {
    code: 'JF',
    name: 'OTT Airlines'
}, {
    code: 'JH',
    name: 'Fuji Dream Airlines'
}, {
    code: 'JJ',
    name: 'LATAM Airlines Brasil'
}, {
    code: 'JK',
    name: 'Aercaribe'
}, {
    code: 'JL',
    name: 'Japan Airlines'
}, {
    code: 'JM',
    name: 'Jambojet Limited'
}, {
    code: 'JN',
    name: 'Alaska Air Transit'
}, {
    code: 'JO',
    name: 'Jonika'
}, {
    code: 'JQ',
    name: 'Jetstar'
}, {
    code: 'JR',
    name: 'Joy Air'
}, {
    code: 'JS',
    name: 'Air Koryo'
}, {
    code: 'JT',
    name: 'Lion Air'
}, {
    code: 'JU',
    name: 'Jat Airways'
}, {
    code: 'JV',
    name: 'Bearskin Airlines'
}, {
    code: 'JX',
    name: 'Starlux Airlines'
}, {
    code: 'JY',
    name: 'Air Turks '
}, {
    code: 'JZ',
    name: 'JetSMART Airlines Peru'
}, {
    code: 'K2',
    name: 'Paklook Air'
}, {
    code: 'K3',
    name: 'Taquan Air Services'
}, {
    code: 'K4',
    name: 'Kalitta Air'
}, {
    code: 'K5',
    name: 'Kalitta Charters II'
}, {
    code: 'K6',
    name: 'Cambodia Angkor Air'
}, {
    code: 'K7',
    name: 'Air KZB Company Limited'
}, {
    code: 'K8',
    name: 'Zambia Skyways'
}, {
    // NOTE: this will map to iata: K9 in the backend
    code: 'KFS',
    name: 'Kalitta Charters'
}, {
    // NOTE: this will map to iata: K9 in the backend
    code: 'TEZ',
    name: 'TezJet'
}, {
    code: 'KA',
    name: 'Aero Nomad Airlines'
}, {
    code: 'KB',
    name: 'Royal Bhutan Airlines'
}, {
    code: 'KC',
    name: 'Air Astana'
}, {
    code: 'KD',
    name: 'KD Avia'
}, {
    code: 'KE',
    name: 'Korean Air'
}, {
    code: 'KF',
    name: 'Air Belgium'
}, {
    code: 'KG',
    name: 'Aerogaviota'
}, {
    code: 'KH',
    name: 'Aloha Air Cargo'
}, {
    code: 'KI',
    name: 'SKS Airways'
}, {
    code: 'KJ',
    name: 'Air Incheon'
}, {
    code: 'KL',
    name: 'KLM'
}, {
    code: 'KM',
    name: 'Air Malta'
}, {
    code: 'KN',
    name: 'China United Airlines'
}, {
    code: 'KO',
    name: 'KHors'
}, {
    code: 'KP',
    name: 'ASKY'
}, {
    code: 'KQ',
    name: 'Kenya Airways'
}, {
    code: 'KR',
    name: 'Cambodia Airways'
}, {
    code: 'KU',
    name: 'Kuwait Airways'
}, {
    code: 'KV',
    name: 'KrasAvia'
}, {
    code: 'KW',
    name: 'AeroStan'
}, {
    code: 'KX',
    name: 'Cayman Airways'
}, {
    code: 'KY',
    name: 'Kunming Airlines'
}, {
    code: 'KZ',
    name: 'NCA - Nippon Cargo Airlines'
}, {
    code: 'L2',
    name: 'Lynden Air Cargo'
}, {
    code: 'L3',
    name: 'DHL de Guatemala'
}, {
    code: 'L4',
    name: 'The Landline Company'
}, {
    code: 'L5',
    name: 'Red Air'
}, {
    code: 'L6',
    name: 'Mauritania Airlines'
}, {
    code: 'L7',
    name: 'LATAM Cargo Colombia'
}, {
    code: 'L8',
    name: 'Lulutai Airlines'
}, {
    code: 'L9',
    name: 'Lumiwings'
}, {
    code: 'LA',
    name: 'LATAM Airlines'
}, {
    code: 'LB',
    name: 'Bul Air'
}, {
    code: 'LD',
    name: 'AHK Air Hong Kong Limited'
}, {
    code: 'LE',
    name: 'Norwegian Air Sweden'
}, {
    code: 'LF',
    name: 'Contour Aviation'
}, {
    code: 'LG',
    name: 'Luxair'
}, {
    code: 'LH',
    name: 'Lufthansa'
}, {
    code: 'LI',
    name: 'Liat'
}, {
    code: 'LJ',
    name: 'Jin Air'
}, {
    code: 'LK',
    name: 'Lao Skyway'
}, {
    code: 'LM',
    name: 'Loganair'
}, {
    code: 'LN',
    name: 'Libyan Airlines'
}, {
    code: 'LO',
    name: 'LOT - Polish Airlines'
}, {
    code: 'LP',
    name: 'LATAM Airlines Peru'
}, {
    code: 'LQ',
    name: 'Lanmei Airlines'
}, {
    code: 'LR',
    name: 'Avianca Costa Rica'
}, {
    code: 'LS',
    name: 'Jet2'
}, {
    code: 'LT',
    name: 'LongJiang Airlines'
}, {
    code: 'LU',
    name: 'LATAM Airlines Chile'
}, {
    code: 'LV',
    name: 'Airzena'
}, {
    code: 'LW',
    name: 'Lauda Europe'
}, {
    code: 'LX',
    name: 'SWISS'
}, {
    code: 'LY',
    name: 'EL AL'
}, {
    code: 'LZ',
    name: 'Belle Air'
}, {
    code: 'M0',
    name: 'Aero Mongolia'
}, {
    code: 'M2',
    name: 'AIR MANAS'
}, {
    code: 'M3',
    name: 'LATAM Cargo Brasil'
}, {
    code: 'M4',
    name: 'Poste Air Cargo'
}, {
    code: 'M5',
    name: 'Kenmore Air'
}, {
    code: 'M6',
    name: 'Amerijet International'
}, {
    code: 'M7',
    name: 'Masair'
}, {
    code: 'M8',
    name: 'Skyjet'
}, {
    code: 'M9',
    name: 'Motor Sich Airlines'
}, {
    code: 'MA',
    name: 'Malev'
}, {
    code: 'MC',
    name: 'Air Mobility Command'
}, {
    code: 'MD',
    name: 'Air Madagascar'
}, {
    code: 'ME',
    name: 'Middle East Airlines'
}, {
    code: 'MF',
    name: 'Xiamen Airlines'
}, {
    code: 'MFX',
    name: '(C6) Centrum Air'
}, {
    code: 'MG',
    name: 'Midex Airlines'
}, {
    code: 'MH',
    name: 'Malaysia Airlines'
}, {
    code: 'MI',
    name: 'Freebird Airlines Europe'
}, {
    code: 'MJ',
    name: 'Myway Airlines'
}, {
    code: 'MK',
    name: 'Air Mauritius'
}, {
    code: 'ML',
    name: 'Sky Mali'
}, {
    code: 'MM',
    name: 'Peach Aviation'
}, {
    code: 'MO',
    name: 'Calm Air International'
}, {
    code: 'MP',
    name: 'Martinair'
}, {
    code: 'MQ',
    name: 'Envoy Air'
}, {
    code: 'MR',
    name: 'Hunnu Air'
}, {
    code: 'MS',
    name: 'EgyptAir'
}, {
    code: 'MU',
    name: 'China Eastern Airlines'
}, {
    code: 'MV',
    name: 'Air Mediterranean'
}, {
    code: 'MW',
    name: 'Mokulele Airlines'
}, {
    code: 'MX',
    name: 'Breeze Airways'
}, {
    code: 'MY',
    name: 'MASwings'
}, {
    code: 'MZ',
    name: 'Amakusa Air'
}, {
    code: 'N0',
    name: 'Norse Atlantic Airways'
}, {
    code: 'N2',
    name: 'Aero Contractors'
}, {
    code: 'N3',
    name: 'Aerolineas MAS'
}, {
    code: 'N4',
    name: 'Nordwind Airlines'
}, {
    code: 'N5',
    name: 'OWG'
}, {
    code: 'N6',
    name: 'Aircompany TCA'
}, {
    code: 'N7',
    name: 'Lagun Air'
}, {
    code: 'N8',
    name: 'National Airlines'
}, {
    code: 'N9',
    name: 'Kabo Air'
}, {
    code: 'NA',
    name: 'North American Airlines'
}, {
    code: 'NB',
    name: 'Berniq Airways'
}, {
    code: 'NC',
    name: 'Northern Air Cargo'
}, {
    code: 'ND',
    name: 'Nordica'
}, {
    code: 'NE',
    name: 'Nesma Airlines'
}, {
    code: 'NF',
    name: 'Air Vanuatu'
}, {
    code: 'NG',
    name: 'NOVAIR'
}, {
    code: 'NH',
    name: 'ANA'
}, {
    code: 'NI',
    name: 'Portugalia Airlines'
}, {
    code: 'NK',
    name: 'Spirit Airlines'
}, {
    code: 'NL',
    name: 'Amelia International'
}, {
    code: 'NP',
    name: 'Nile Air'
}, {
    code: 'NQ',
    name: 'Air Japan'
}, {
    code: 'NR',
    name: 'Manta Aviation'
}, {
    code: 'NS',
    name: 'Hebei Airlines'
}, {
    code: 'NT',
    name: 'Binter Canarias'
}, {
    code: 'NU',
    name: 'Japan Transocean Air'
}, {
    code: 'NX',
    name: 'Air Macau'
}, {
    code: 'NY',
    name: 'Air Iceland Connect'
}, {
    code: 'NZ',
    name: 'Air New Zealand'
}, {
    code: 'O2',
    name: 'Linear Air'
}, {
    code: 'O3',
    name: 'SF Airlines'
}, {
    code: 'O7',
    name: 'Orenburzhye'
}, {
    code: 'OA',
    name: 'Olympic Air'
}, {
    code: 'OB',
    name: 'BoA'
}, {
    code: 'OC',
    name: 'Oriental Air Bridge'
}, {
    code: 'OD',
    name: 'Batik Air Malaysia'
}, {
    code: 'OF',
    name: 'Overland Airways'
}, {
    code: 'OG',
    name: 'Fly Play'
}, {
    code: 'OH',
    name: 'PSA Airlines'
}, {
    code: 'OI',
    name: 'Hinterland Aviation'
}, {
    code: 'OJ',
    name: 'NyxAir'
}, {
    code: 'OK',
    name: 'CSA'
}, {
    code: 'OL',
    name: 'Samoa Airways'
}, {
    code: 'OM',
    name: 'Miat - Mongolian Airlines'
}, {
    code: 'ON',
    name: 'Nauru Airlines'
}, {
    code: 'OO',
    name: 'SkyWest Airlines'
}, {
    code: 'OP',
    name: 'Passion Air'
}, {
    code: 'OQ',
    name: 'Chongqing Airlines'
}, {
    code: 'OR',
    name: 'TUIfly Netherlands'
}, {
    code: 'OS',
    name: 'Austrian'
}, {
    code: 'OT',
    name: 'Tchadia Airlines'
}, {
    code: 'OU',
    name: 'Croatia Airlines'
}, {
    code: 'OV',
    name: 'SalamAir'
}, {
    code: 'OW',
    name: 'Skyward Express'
}, {
    code: 'OY',
    name: 'Omni Air International'
}, {
    code: 'OZ',
    name: 'Asiana Airlines'
}, {
    code: 'P0',
    name: 'Proflight Zambia'
}, {
    code: 'P1',
    name: 'Public Charters'
}, {
    code: 'P2',
    name: 'AirKenya Express Limited'
}, {
    code: 'P3',
    name: 'VoePass'
}, {
    code: 'P4',
    name: 'Air Peace'
}, {
    code: 'P5',
    name: 'Copa Airlines Colombia'
}, {
    code: 'P6',
    name: 'Pascan Aviation Inc.'
}, {
    code: 'P8',
    name: 'Sprint Air'
}, {
    code: 'P9',
    name: 'Peruvian Airlines'
}, {
    code: 'PA',
    name: 'Airblue'
}, {
    code: 'PB',
    name: 'PAL Airlines'
}, {
    code: 'PC',
    name: 'Pegasus'
}, {
    code: 'PD',
    name: 'Porter Airlines'
}, {
    code: 'PE',
    name: 'Phoebus Apollo Aviation'
}, {
    code: 'PF',
    name: 'Primera Air Scandinavia'
}, {
    code: 'PG',
    name: 'Bangkok Airways'
}, {
    code: 'PI',
    name: 'Polar Airlines'
}, {
    code: 'PJ',
    name: 'Air Saint Pierre'
}, {
    code: 'PK',
    name: 'Pakistan International Airlines'
}, {
    code: 'PL',
    name: 'Southern Air Charter'
}, {
    code: 'PM',
    name: 'Pamir Airways'
}, {
    code: 'PN',
    name: 'West Air (China)'
}, {
    code: 'PO',
    name: 'Polar Air Cargo'
}, {
    code: 'PP',
    name: 'Jet Aviation Business'
}, {
    code: 'PQ',
    name: 'SkyUP Airlines'
}, {
    code: 'PR',
    name: 'Philippine Airlines'
}, {
    code: 'PS',
    name: 'UIA'
}, {
    code: 'PT',
    name: 'Piedmont Airlines'
}, {
    code: 'PU',
    name: 'Plus Ultra'
}, {
    code: 'PV',
    name: 'Saint Barth Commuter'
}, {
    code: 'PW',
    name: 'Precision Air'
}, {
    code: 'PX',
    name: 'Air Niugini'
}, {
    code: 'PY',
    name: 'Surinam Airways'
}, {
    code: 'PZ',
    name: 'LATAM Airlines Paraguay'
}, {
    code: 'Q2',
    name: 'Maldivian'
}, {
    code: 'Q3',
    name: 'Anguilla Air Services'
}, {
    code: 'Q4',
    name: 'Starlink Aviation'
}, {
    code: 'Q5',
    name: '40-Mile Air'
}, {
    code: 'Q6',
    name: 'Skytrans'
}, {
    code: 'Q7',
    name: 'DHL Air Austria'
}, {
    code: 'Q9',
    name: 'Green Africa Airways'
}, {
    code: 'QB',
    name: 'Qeshm Air'
}, {
    code: 'QC',
    name: 'Camair-Co'
}, {
    // NOTE: this will map to VZ in the backend
    code: 'QCL',
    name: '(VZ) Airclass Lineas Aereas'
}, {
    code: 'QD',
    name: 'JC International Airlines'
}, {
    code: 'QE',
    name: 'Express Freighters Australia'
}, {
    code: 'QF',
    name: 'Qantas'
}, {
    code: 'QG',
    name: 'Citilink'
}, {
    code: 'QH',
    name: 'Altyn Air'
}, {
    code: 'QI',
    name: 'Ibom Air'
}, {
    code: 'QJ',
    name: 'Jet Airways'
}, {
    code: 'QK',
    name: 'Jazz'
}, {
    code: 'QL',
    name: 'LASER Airlines'
}, {
    code: 'QM',
    name: 'Air Malawi'
}, {
    code: 'QN',
    name: 'Skytrans'
}, {
    code: 'QP',
    name: 'Akasa Air'
}, {
    code: 'QQ',
    name: 'Alliance Airlines'
}, {
    code: 'QR',
    name: 'Qatar Airways'
}, {
    code: 'QS',
    name: 'SmartWings'
}, {
    code: 'QT',
    name: 'Avianca Cargo'
}, {
    code: 'QU',
    name: 'Azur Air Ukraine'
}, {
    code: 'QV',
    name: 'Lao Airlines'
}, {
    code: 'QW',
    name: 'Qingdao Airlines'
}, {
    code: 'QX',
    name: 'Horizon Air'
}, {
    code: 'QY',
    name: 'EAT Leipzig'
}, {
    code: 'QZ',
    name: 'Indonesia AirAsia'
}, {
    code: 'R2',
    name: 'Groupe Transair'
}, {
    code: 'R3',
    name: 'Yakutia'
}, {
    code: 'R5',
    name: 'Jordan Aviation Airlines'
}, {
    code: 'R6',
    name: 'DAT LT'
}, {
    code: 'R9',
    name: 'Trans Executive Airlines of Hawaii'
}, {
    code: 'RA',
    name: 'Nepal Airlines'
}, {
    code: 'RB',
    name: 'Syrian Air'
}, {
    code: 'RC',
    name: 'Atlantic Airways'
}, {
    code: 'RG',
    name: 'Rotana Jet'
}, {
    code: 'RH',
    name: 'Hong Kong Air Cargo Carrier'
}, {
    code: 'RI',
    name: 'Rimbun Abadi Aviasi'
}, {
    code: 'RJ',
    name: 'Royal Jordanian'
}, {
    code: 'RK',
    name: 'Ryanair UK'
}, {
    code: 'RL',
    name: 'Royal Flight Airlines'
}, {
    code: 'RM',
    name: 'Aircompany Armenia'
}, {
    code: 'RO',
    name: 'TAROM'
}, {
    code: 'RP',
    name: 'Base Kft'
}, {
    code: 'RQ',
    name: 'Kam Air'
}, {
    code: 'RR',
    name: 'Royal Air Force'
}, {
    code: 'RS',
    name: 'Sky Regional'
}, {
    code: 'RT',
    name: 'UVT Aero'
}, {
    code: 'RU',
    name: 'AirBridgeCargo'
}, {
    code: 'RV',
    name: 'Caspian Airlines'
}, {
    code: 'RW',
    name: 'Royal Air'
}, {
    code: 'RY',
    name: 'Jiangxi Airlines'
}, {
    code: 'RZ',
    name: 'SANSA Regional'
}, {
    code: 'S0',
    name: 'Aerolineas Sosa'
}, {
    code: 'S4',
    name: 'Azores Airlines'
}, {
    code: 'S5',
    name: 'Shuttle America'
}, {
    code: 'S6',
    name: 'Salmon Air'
}, {
    code: 'S7',
    name: 'S7 Airlines'
}, {
    code: 'S9',
    name: 'Starbow'
}, {
    code: 'SA',
    name: 'South African Airways'
}, {
    code: 'SB',
    name: 'Aircalin'
}, {
    code: 'SC',
    name: 'Shandong Airlines'
}, {
    code: 'SD',
    name: 'Sudan Airways'
}, {
    code: 'SE',
    name: 'European Cargo Limited'
}, {
    code: 'SF',
    name: 'Tassili Airlines'
}, {
    code: 'SG',
    name: 'SpiceJet'
}, {
    code: 'SH',
    name: 'Sharp Airlines'
}, {
    code: 'SI',
    name: 'Blue Islands'
}, {
    code: 'SJ',
    name: 'Sriwijaya Air'
}, {
    code: 'SK',
    name: 'SAS'
}, {
    code: 'SL',
    name: 'Thai Lion Air'
}, {
    code: 'SM',
    name: 'Air Cairo'
}, {
    code: 'SN',
    name: 'Brussels Airlines'
}, {
    code: 'SO',
    name: 'SALSA d'
}, {
    code: 'SP',
    name: 'SATA Air Acores'
}, {
    code: 'SQ',
    name: 'Singapore Airlines'
}, {
    code: 'SR',
    name: 'SundAir'
}, {
    code: 'SS',
    name: 'Corsair'
}, {
    code: 'SU',
    name: 'Aeroflot'
}, {
    code: 'SV',
    name: 'Saudia'
}, {
    code: 'SX',
    name: 'Skybus Airlines'
}, {
    code: 'SY',
    name: 'Sun Country Airlines'
}, {
    code: 'SZ',
    name: 'Somon Air'
}, {
    code: 'T2',
    name: 'MCS Aerocarga de Mexico'
}, {
    code: 'T3',
    name: 'Eastern Airways'
}, {
    code: 'T4',
    name: 'Rhoades Aviation'
}, {
    code: 'T5',
    name: 'Turkmenistan Airlines'
}, {
    code: 'T6',
    name: 'AirSWIFT'
}, {
    code: 'T7',
    name: 'Twin Jet'
}, {
    code: 'T8',
    name: 'Terra Avia'
}, {
    code: 'T9',
    name: 'Turpial Airlines'
}, {
    code: 'TA',
    name: 'TACA'
}, {
    code: 'TB',
    name: 'TUI fly'
}, {
    code: 'TC',
    name: 'Air Tanzania'
}, {
    code: 'TD',
    name: 'Atlantis European Airway'
}, {
    code: 'TE',
    name: 'Sky Taxi'
}, {
    code: 'TF',
    name: 'Braathens Regional'
}, {
    code: 'TG',
    name: 'Thai Airways International'
}, {
    code: 'TH',
    name: 'Raya Airways'
}, {
    code: 'TJ',
    name: 'Tradewind Aviation'
}, {
    code: 'TK',
    name: 'Turkish Airlines'
}, {
    code: 'TL',
    name: 'TMA Cargo'
}, {
    code: 'TM',
    name: 'Lam Mozambique'
}, {
    code: 'TN',
    name: 'Air Tahiti Nui'
}, {
    code: 'TO',
    name: 'Transavia France'
}, {
    code: 'TP',
    name: 'TAP Air Portugal'
}, {
    code: 'TQ',
    name: 'Tailwind Air'
}, {
    code: 'TR',
    name: 'Scoot'
}, {
    code: 'TS',
    name: 'Air Transat'
}, {
    code: 'TU',
    name: 'Tunisair'
}, {
    code: 'TV',
    name: 'Tibet Airlines'
}, {
    code: 'TW',
    name: 'T\'Way Air'
}, {
    code: 'TX',
    name: 'Air Caraibes'
}, {
    code: 'TY',
    name: 'Air Caledonie'
}, {
    code: 'TZ',
    name: 'ATA Airlines'
}, {
    code: 'U0',
    name: 'Ultra Air'
}, {
    code: 'U2',
    name: 'easyJet'
}, {
    code: 'U3',
    name: 'Sky Gates Airlines'
}, {
    code: 'U4',
    name: 'PMT Air'
}, {
    code: 'U5',
    name: 'Gowair'
}, {
    code: 'U6',
    name: 'Ural Airlines'
}, {
    code: 'U7',
    name: 'Uniworld Air Cargo'
}, {
    code: 'U8',
    name: 'Tus Airways'
}, {
    code: 'UA',
    name: 'United Airlines'
}, {
    code: 'UB',
    name: 'Myanmar National Airlines'
}, {
    code: 'UC',
    name: 'LATAM Cargo Chile'
}, {
    code: 'UD',
    name: 'UBD'
}, {
    code: 'UE',
    name: 'Ultimate Air Shuttle'
}, {
    code: 'UF',
    name: 'Petroleum Air Services'
}, {
    code: 'UG',
    name: 'Tunisair Express'
}, {
    code: 'UH',
    name: 'Jet Exchange'
}, {
    code: 'UI',
    name: 'Auric Air'
}, {
    code: 'UJ',
    name: 'Almasria Universal Airlines'
}, {
    code: 'UK',
    name: 'Vistara'
}, {
    code: 'UL',
    name: 'SriLankan Airlines'
}, {
    code: 'UM',
    name: 'Air Zimbabwe'
}, {
    code: 'UO',
    name: 'Hong Kong Express'
}, {
    code: 'UP',
    name: 'Bahamasair'
}, {
    code: 'UQ',
    name: 'Urumqi Airlines'
}, {
    code: 'UR',
    name: 'Uganda Airlines'
}, {
    code: 'UT',
    name: 'UTair Aviation'
}, {
    code: 'UU',
    name: 'Air Austral'
}, {
    code: 'UV',
    name: 'Babcock MCS Espana'
}, {
    code: 'UX',
    name: 'Air Europa'
}, {
    code: 'UY',
    name: 'Sky Prime Charter'
}, {
    code: 'UZ',
    name: 'Buraq Air'
}, {
    code: 'V0',
    name: 'Conviasa'
}, {
    code: 'V2',
    name: 'Avialeasing'
}, {
    code: 'V3',
    name: 'Carpatair'
}, {
    code: 'V4',
    name: 'Vieques Air Link'
}, {
    code: 'V5',
    name: 'Aerovias DAP'
}, {
    code: 'V7',
    name: 'Volotea'
}, {
    code: 'V8',
    name: 'Iliamna Air Taxi'
}, {
    code: 'V9',
    name: 'Citywing'
}, {
    code: 'VA',
    name: 'Virgin Australia'
}, {
    code: 'VB',
    name: 'VivaAerobus'
}, {
    code: 'VC',
    name: 'ViaAir'
}, {
    code: 'VE',
    name: 'EasyFly'
}, {
    code: 'VG',
    name: 'Vipper BV'
}, {
    code: 'VH',
    name: 'VIVAAIR'
}, {
    code: 'VI',
    name: 'Volga-Dnepr'
}, {
    code: 'VJ',
    name: 'VietJet Air'
}, {
    code: 'VK',
    name: 'Valuejet'
}, {
    code: 'VM',
    name: 'Avianca Argentina'
}, {
    code: 'VN',
    name: 'Vietnam Airlines'
}, {
    code: 'VP',
    name: 'Flyme'
}, {
    code: 'VQ',
    name: 'Novoair'
}, {
    code: 'VR',
    name: 'TACV Cabo Verde Airlines'
}, {
    code: 'VS',
    name: 'Virgin Atlantic'
}, {
    code: 'VT',
    name: 'Air Tahiti'
}, {
    code: 'VU',
    name: 'Vietravel Airlines'
}, {
    code: 'VV',
    name: 'Viva Airlines Peru'
}, {
    code: 'VW',
    name: 'Aeromar'
}, {
    code: 'VY',
    name: 'Vueling'
}, {
    // NOTE: this will map to VZ in the backend
    code: 'TVJ',
    name: '(VZ) Thai Vietjet Air'
}, {
    code: 'W2',
    name: 'FlexFlight'
}, {
    code: 'W3',
    name: 'Arik Air Limited'
}, {
    code: 'W4',
    name: 'Wizz Air Malta'
}, {
    code: 'W5',
    name: 'Mahan Air'
}, {
    code: 'W6',
    name: 'Wizz Air'
}, {
    code: 'W7',
    name: 'Sayakhat Airlines'
}, {
    code: 'W8',
    name: 'Cargojet'
}, {
    code: 'W9',
    name: 'Wizz Air UK'
}, {
    code: 'WA',
    name: 'KLM Cityhopper'
}, {
    code: 'WB',
    name: 'RwandAir'
}, {
    code: 'WC',
    name: 'Avianca Honduras'
}, {
    code: 'WE',
    name: 'Centurion Cargo'
}, {
    code: 'WF',
    name: 'Wideroe'
}, {
    code: 'WG',
    name: 'Sunwing'
}, {
    code: 'WI',
    name: 'White Airways'
}, {
    code: 'WJ',
    name: 'Air Labrador'
}, {
    code: 'WK',
    name: 'Edelweiss Air'
}, {
    code: 'WL',
    name: 'World Atlantic Airlines'
}, {
    code: 'WM',
    name: 'Winair'
}, {
    code: 'WN',
    name: 'Southwest Airlines'
}, {
    code: 'WO',
    name: 'World Airways'
}, {
    code: 'WR',
    name: 'WestJet Encore'
}, {
    code: 'WS',
    name: 'WestJet'
}, {
    code: 'WT',
    name: 'Swiftair'
}, {
    code: 'WU',
    name: 'Western Air'
}, {
    code: 'WV',
    name: 'FlyNamibia'
}, {
    code: 'WW',
    name: 'Kargo Xpress'
}, {
    code: 'WX',
    name: 'Cityjet'
}, {
    code: 'WY',
    name: 'Oman Air'
}, {
    code: 'WZ',
    name: 'Red Wings'
}, {
    code: 'X3',
    name: 'TUIfly'
}, {
    code: 'X4',
    name: 'Aleutian Airways'
}, {
    code: 'X5',
    name: 'Air Europa Express'
}, {
    code: 'X7',
    name: 'Challenge Airlines'
}, {
    code: 'X9',
    name: 'JSC Avion Express'
}, {
    code: 'XA',
    name: 'ARINC'
}, {
    code: 'XC',
    name: 'Corendon Air'
}, {
    code: 'XE',
    name: 'Korea Express Air'
}, {
    code: 'XF',
    name: 'Mongolian Airways'
}, {
    code: 'XJ',
    name: 'Thai AirAsia X'
}, {
    code: 'XK',
    name: 'Air Corsica'
}, {
    code: 'XL',
    name: 'LATAM Airlines Ecuador'
}, {
    code: 'XM',
    name: 'Zimex Aviation'
}, {
    code: 'XN',
    name: 'Manasik Aviation'
}, {
    code: 'XO',
    name: 'South East Asian Airlines (SEAIR)'
}, {
    code: 'XP',
    name: 'Avelo Airlines'
}, {
    code: 'XQ',
    name: 'SunExpress'
}, {
    code: 'XR',
    name: 'Corendon Airlines Europe'
}, {
    code: 'XT',
    name: 'GloBus'
}, {
    code: 'XU',
    name: 'African Express Airways'
}, {
    code: 'XY',
    name: 'flynas'
}, {
    code: 'XZ',
    name: 'Aeroitalia'
}, {
    code: 'Y2',
    name: 'Air Century'
}, {
    code: 'Y4',
    name: 'Volaris'
}, {
    code: 'Y5',
    name: 'Golden Myanmar Airlines Public Co. Ltd'
}, {
    code: 'Y6',
    name: 'AB Aviation'
}, {
    code: 'Y7',
    name: 'NordStar Airlines'
}, {
    code: 'Y8',
    name: 'Suparna Airlines'
}, {
    code: 'Y9',
    name: 'Lynx Air'
}, {
    code: 'YB',
    name: 'Harbour Air'
}, {
    code: 'YC',
    name: 'Yamal Airlines'
}, {
    code: 'YD',
    name: 'Synergy Aviation'
}, {
    code: 'YE',
    name: 'YanAir'
}, {
    code: 'YG',
    name: 'YTO Cargo'
}, {
    code: 'YH',
    name: 'Air Thanlwin'
}, {
    code: 'YI',
    name: 'FLY OYA'
}, {
    code: 'YJ',
    name: 'Asian Express General Aviation Wuxi'
}, {
    code: 'YK',
    name: 'Avia Traffic Company LLC'
}, {
    code: 'YL',
    name: 'Libyan Wings'
}, {
    code: 'YN',
    name: 'Air Creebec'
}, {
    code: 'YO',
    name: 'Heli Air Monaco'
}, {
    code: 'YP',
    name: 'Air Premia'
}, {
    code: 'YQ',
    name: 'TAR Aerolineas'
}, {
    code: 'YR',
    name: 'Scenic Airlines'
}, {
    code: 'YS',
    name: 'Flightlink Limited'
}, {
    code: 'YT',
    name: 'Yeti Airlines'
}, {
    code: 'YU',
    name: 'EuroAtlantic Airways'
}, {
    code: 'YV',
    name: 'Mesa Airlines'
}, {
    code: 'YW',
    name: 'Air Nostrum'
}, {
    code: 'YX',
    name: 'Republic Airways'
}, {
    code: 'Z0',
    name: 'Norse Atlantic UK'
}, {
    code: 'Z2',
    name: 'Philippines AirAsia'
}, {
    code: 'Z7',
    name: 'Camex Airlines'
}, {
    code: 'Z8',
    name: 'Amaszonas SA'
}, {
    code: 'ZA',
    name: 'Sky Angkor Airlines Co., Ltd'
}, {
    code: 'ZB',
    name: 'Air Albania'
}, {
    code: 'ZD',
    name: 'EWA Air'
}, {
    code: 'ZF',
    name: 'Athens Airways'
}, {
    code: 'ZG',
    name: 'ZIPAIR Tokyo'
}, {
    code: 'ZH',
    name: 'Shenzhen Airlines'
}, {
    code: 'ZJ',
    name: 'ARINC Direct'
}, {
    code: 'ZK',
    name: 'Great Lakes Airlines'
}, {
    code: 'ZL',
    name: 'Rex Regional Express'
}, {
    code: 'ZM',
    name: 'Air Manas Air Company LLC'
}, {
    code: 'ZN',
    name: 'Zambia Airways'
}, {
    code: 'ZQ',
    name: 'WDL Aviation'
}, {
    code: 'ZR',
    name: 'Aviacon Zitotrans'
}, {
    code: 'ZT',
    name: 'Titan Airways'
}, {
    code: 'ZV',
    name: 'Aerotransportes Rafilher'
}, {
    code: 'ZW',
    name: 'Air Wisconsin'
}, {
    code: 'ZX',
    name: 'Pivot Airlines'
}];

exports.default = airlines;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/utils/airlines.js
// module id = 638
// module chunks = 0